import React, { useEffect, useState } from 'react'
import { BrandingTab, BrandingTabContainer, ContainerMain } from '../common/commonStyles'
// import { AdminDownloadIcon } from '../../utils/icons';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import HoverButton from '../common/HoverButton';
import dayjs from 'dayjs';
// import { CommonFilterDropdown } from '../common/CommonYearFilter/CommonYearFilter';
import { GetCompanyAdminRewardPeriods, GetRewardsReport } from '../../redux/constants/apiConstants';
import { fetchApi } from '../../utils/methods';
import { toast } from 'react-toastify';
import CSVList from '../PeopleHomeV2/CSVList';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import Rewards from './Rewards/Rewards';
import Documents from './Documents/Documents';
import CommonDropdown from '../common/CommonDropDown/CommonDropdown';
import SkeletonLoder from '../common/skeletonLoder';
import ReportModal from './Rewards/ReportModal';
const tabs = [
  { label: 'Rewards', path: 'rewards', component: Rewards },
  { label: 'Documents', path: 'documents', component: Documents },
  // future-proof
  // { label: 'Settings', path: 'settings', component: Settings },
];


const AdminRewardsManagement = ({brandingColor, companyInfo,history,match}) => {
  const [selectedYear, setSelectedYear] = useState(dayjs().format("YYYY"));
  const[printRewardCSV, setprintRewardCSV] = useState(false);
  const [rewardReportData, setRewardReportData] = useState([]);
  const[monthDropdownOpen,setMonthDropdownOpen] = useState(false);
  const [rewardPeriodData, setRewardPeriodData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showReportPopup, setShowReportPopup] = useState(false);

  useEffect(()=>{
    fetchCompanyRewardsDetailsYearwise()
  },[])

  useEffect(()=>{
    if(rewardReportData.length > 0){
      setprintRewardCSV(true);
    }
  },[rewardReportData]);

  const selectYearData = (value) => {
    setSelectedYear(value)
    // fetchTopCardsAndGraph(value)
  }

  const handleTabClick = (path) => {
    history.push(`${match.url}/${path}`);
  };

  const printAction = (bool) => {
    setprintRewardCSV(bool)
  }

  const fetchCompanyRewardsDetailsYearwise = async() =>{
    setLoading(true);
    try {

      const companyRewardsData = await fetchApi(GetCompanyAdminRewardPeriods+'?company_id='+ companyInfo.id , "GET");
      if(companyRewardsData.status === 'success'){
        setRewardPeriodData(companyRewardsData?.data?.periods);
        setSelectedYear(companyRewardsData?.data?.periods?.[0])
      }else{
        toast.error(companyRewardsData.message);
      }
    } catch (error) {
      toast.error(error);
      
    }finally{
      setLoading(false);
    }
  }

  const getRewardReport = async(year)=>{
    const companyRewardsReport = await fetchApi(GetRewardsReport+'/'+companyInfo?.id + (year && `/${year}`) , "GET");
    setRewardReportData(companyRewardsReport.data);
    if(companyRewardsReport.data.length === 0){
      toast.error("No data found");
      return;
    }
    // getCSVHeaders(companyRewardsReport.data[0]);
    if(companyRewardsReport.message){
      toast.error(companyRewardsReport.message);
      return;
    }else{
      setprintRewardCSV(false);

    }
  }



  const getCSVHeaders = () => {
    let object = rewardReportData[0];
    let keysArray = object && Object.keys(object);
    
    // Extract the values for "Finished", "Gold", "Silver", and "Bronze"
    const finished = keysArray && keysArray.find((key) => key.includes("Finished"));
    const gold = keysArray && keysArray.find((key) => key.includes("Gold"));
    const silver = keysArray && keysArray.find((key) => key.includes("Silver"));
    const bronze = keysArray && keysArray.find((key) => key.includes("Bronze"));
  
    const csvHeaders = [
      { label: "User ID", key: "uid" },
      { label: "First Name", key: "FIRST NAME" },
      { label: "Last Name", key: "LAST NAME" },
      { label: "Email", key: "EMAIL" },
      { label: "Department", key: "DEPARTMENT" },
      { label: "Location", key: "LOCATION" },
      { label: "Team", key: "TEAM NAME" },
    ];
  
    if (bronze) {
      csvHeaders.push({ label: bronze, key: bronze });
    }
    if (silver) {
      csvHeaders.push({ label: silver, key: silver });
    }
    if (gold) {
      csvHeaders.push({ label: gold, key: gold });
    }
    if (finished) {
      csvHeaders.push({ label: finished, key: finished });
    }
  
    return csvHeaders;
  };

  const getActivePath = () => {
    const current = history.location.pathname;
    const found = tabs.find((tab) => current.endsWith(tab.path));
    return found?.path;
  };

  if (loading) {
    return (
      <ContainerMain padding={"25px 0px 0px 0px"}>
        <div className='content-wrap'>
          {Array.from({ length: 1 }).map((_, index) => (
            <SkeletonLoder
              key={index}
              width="1248px"
              height="190px"
              style={{ gap: "25px" }}
            />
          ))}
        </div>
      </ContainerMain>
    );
  }
  

  return (
    <>
      <ContainerMain padding={"25px 0px 0px 0px"}>
        <div className='content-wrap'>
          <BrandingTabContainer isCompare={"0px"}>
            <div className='wrapper'>
              {tabs.map((tab) => (
                <BrandingTab
                  key={tab.id}
                  onClick={() => handleTabClick(tab.path)}
                  active={getActivePath() === tab.path}
                  background={brandingColor ? brandingColor : "#0b4170"}
                  id={"step"+tab.id}
                >
                  {tab.label}
                </BrandingTab>
              ))}
            </div>
    
            {/* {rewardPeriodData.length ?<div style={{ margin: "0 10px 0 0", cursor: "pointer" }}>
              <HoverButton
                title={"Download"}
                onClick={()=>setShowReportPopup(true)}
                marginLeft={"0px"}
                fillOpacity={1}
                activeColor={"#DA6C74"}
                inActiveColor={"#DA6C74"}
                backgroundColor={"white"}
                backgroundColorActive={"#DA6C74"}
                width={"24px"}
                height={"24px"}
                
                svgPath={<AdminDownloadIcon width="24px" height="24px"/>}
              />
            </div>:null} */}
            {rewardPeriodData.length ? <div style={{display:'flex',alignItems:'center'}}>
              {/* <CommonFilterDropdown
                options={yearList}
                selectedOption={selectedYear}
                setSelectedOption={selectYearData}    
                dropdownHeight={"auto"}
              /> */}

              <CommonDropdown
                tileContainerStyle={{ width: "100%", padding:"0px", margin: "0px" }}
                dropdownButtonPadding={"0px 35px 0px 12px"}
                dropdownStyle={{ top: "95px" }}
                // labelText={""}
                isRequired={true}
                dropdownOpen={monthDropdownOpen}
                placeholder={"Year"}
                title={
                  dayjs(selectedYear?.reward_start_date).format("MMM YYYY") + " - " + dayjs(selectedYear?.reward_end_date).format("MMM YYYY")
                }
                id="dropdown-recurring"
                onClick={() => setMonthDropdownOpen(!monthDropdownOpen)}
                data={rewardPeriodData}
                active={selectedYear}
                onSelectParameter={["year", "firstDate", "month"]}
                // valueString={"Points"}
                itemValue={true}
                valueIndex={0}
                labelMargin={"0px"}
                onSelect={selectYearData}
                dropIcon={true}
                isManagerMargin={'0px'}
                top={'8px'}
                showDateRange={true}
                dateRangeKeys={{
                  start: "reward_start_date",
                  end: "reward_end_date"
                }}
              />
            </div>:null}
          </BrandingTabContainer>
        </div>
      </ContainerMain>

      {printRewardCSV && <CSVList Title={`${"Rewards Report"}_${companyInfo.name}`} removeCSVData={printAction} headers={getCSVHeaders()} data={rewardReportData} />}
      <div style={{width:'1248px',margin:'auto'}}>
        <Switch>
          {/* default redirect */}
          <Route
            exact
            path={match.path}
            render={() => <Redirect to={`${match.url}/rewards`} />}
          />
        
          {tabs.map(({ path, component: Component }) => (
            <Route
              key={path}
              path={`${match.path}/${path}`}
              render={(routeProps) =>
                path === 'rewards' ? (
                  <Component
                    {...routeProps}
                    companyInfo={companyInfo}
                    selectedYear={selectedYear}
                    getRewardReport={getRewardReport}
                    // companyRewardDetails={companyRewardDetails}
                  />
                ) : (
                  <Component {...routeProps}  companyInfo={companyInfo} selectedYear={selectedYear}/>
                )
              }
            />
          ))}
  
        </Switch>
      </div>

      {showReportPopup && <ReportModal show={showReportPopup} title={'Export Rewards Report'} onCancel={()=>setShowReportPopup(false)}companyInfo={companyInfo}/>}
    </>
  )
}

AdminRewardsManagement.propTypes = {
  brandingColor: PropTypes.string,
  yearList:PropTypes.array,
  companyInfo:PropTypes.object,
  history:PropTypes.object,
  match:PropTypes.object
}

const mapStateToProps = (state) => ({
  brandingColor:state.wellnessDashboard.brandingColor,
});

export default withRouter(connect(mapStateToProps)(AdminRewardsManagement));
